"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.home = void 0;
exports.home = {
  id: 'home',
  path: '/',
  type: 'page',
  icon: function (_a) {
    var icons = _a.icons;
    return icons.AppSections.Home;
  },
  label: 'Home'
};